import { useState, useEffect } from 'react';
import Modal from "react-modal";

const TaxRegimeModal = ({ isOpen, onClose, taxRegimeType }) => {

    useEffect(() => {

    }, []);

    return (
        // <Modal
        //     isOpen={isOpen}
        //     onRequestClose={onClose}
        //     contentLabel="Success Modal"
        //     className="modal-sm success-modal p-5"
        // >
        //     <div className="d-flex flex-column align-items-center">
        //         <div className="mb-3">
        //             <p className="font-xxl extraBold text-center">New Tax Regime!</p>
        //         </div>
        //         <div className="mb-3">
        //             <p className="font-sm extraBold text-center">You are under the New Tax Regime.</p>
        //         </div>
        //         <div>
        //             <button
        //                 className="btn btn-primary"
        //                 onClick={onClose}
        //                 autoFocus
        //             >
        //                 <span className="font-lg font-bold px-5">OK</span>
        //             </button>
        //         </div>
        //     </div>
        // </Modal>
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Investment Declaration Modal"
            className="modal-lg p-0"
            style={{
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                },
                content: {
                    position: "relative",
                    inset: "unset",
                    border: "none",
                    borderRadius: "6px",
                    padding: 0,
                    width: "480px",
                    maxWidth: "95vw",
                    overflow: "hidden",
                },
            }}
        >

            <div
                className="d-flex align-items-center justify-content-between px-3"
                style={{ background: "#C0392B", padding: "11px 16px" }}
            >
                <span className="font-md extraBold" style={{ color: "#fff" }}>
                    Investment Declaration
                </span>
            </div>

            <div className="d-flex flex-column align-items-center p-5">
                <div
                    className="mb-3 d-flex align-items-center justify-content-center"
                    style={{
                        width: 52,
                        height: 52,
                        background: "#F5A623",
                        borderRadius: "50%",
                    }}
                >
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="2" />
                        <path d="M12 8v4" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        <circle cx="12" cy="16" r="1.2" fill="#fff" />
                    </svg>
                </div>

                <div className="mb-2">
                    <p className="font-md extraBold text-center mb-0">
                        You are under the <strong>{taxRegimeType}.</strong>
                    </p>
                </div>

                <div className="mb-4">
                    <p className="font-md text-center mb-0" style={{ color: "#666" }}>
                        No Investment Declaration submission is required.
                    </p>
                </div>

                <div>
                    <button
                        className="btn btn-danger"
                        onClick={onClose}
                        autoFocus
                        style={{ background: "#C0392B", border: "none", borderRadius: 4 }}
                    >
                        <span className="font-sm font-bold px-5">CLOSE</span>
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default TaxRegimeModal;